import LogManager from "./LogManager";

/**
 * Utility functions for managing summary reviewer settings
 */


/**
 * Updates the summary reviewer setting via API
 * @param {Object} params - The parameters for the API call
 * @param {string} params.rtmsStreamId - The RTMS stream ID
 * @param {string} params.meetingUuid - The meeting UUID
 * @param {string} params.meetingId - The meeting ID
 * @param {string} params.alias - The user's alias
 * @param {boolean} params.checked - Whether the toggle is checked (true = send to all attendees)
 * @returns {Promise<boolean>} - Returns true if successful, false if failed
 */
export const updateSummaryReviewers = async ({ rtmsStreamId, meetingUuid, meetingId, alias, checked }) => {
  const payload = {
    rtmsStreamId: rtmsStreamId,
    meetingUuid: meetingUuid,
    meetingId: meetingId,
    updateTime: Math.floor(Date.now() / 1000),
    reviewer: checked ? "" : alias
  };

  LogManager.info("Calling /summary-reviewer. Request body is: " + JSON.stringify(payload));

  try {
    const response = await fetch('/summary-reviewer', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      LogManager.error('Failed to update summary reviewer setting. Status:', response.status, 'StatusText:', response.statusText);
      return false;
    }

    const responseJson = await response.json();
    LogManager.info("Successfully updated summary reviewer setting. Response:", JSON.stringify(responseJson));
    return true;
  } catch (error) {
    LogManager.error('Error updating summary reviewer setting:', error);
    return false;
  }
};
